import { UserCohort } from 'owa-bizchat-types/lib/UserCohort';
import { getUserCohort } from 'owa-sidepane-bizchat-store';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import type { MailboxInfo } from 'owa-client-types';

/**
 * This function determines if the user falls into the category of "Starter" or "MSA" user.
 * In the context of getSuggestions(), those users should not have any SUAs shown to them
 * in the mail tab (no e-mail selected) scenario.
 */
export function isUserStarterOrMSA(mailboxInfo: MailboxInfo): boolean {
    const userCohort = getUserCohort(mailboxInfo);
    const isConsumerUser = isConsumer(undefined /* smtpAddress */, mailboxInfo);
    const isStarterUser = !isConsumerUser && userCohort === UserCohort.BCWAF;
    const isMSAUser =
        isConsumerUser && (userCohort === UserCohort.BCWAF || userCohort === UserCohort.BCAIS);
    return isStarterUser || isMSAUser;
}
